<template>
     <div class="main-container incidentals">
            <h1>广州机场空运出口港杂费收费标准(币制RMB）</h1>
            <table class="">
                <tr style="height:36px;">
                    <td>报关费</td>
                    <td>250.00/份(客户提供单证, 且非电商类报关）</td>
                </tr>
                <tr style="height:36px;">
                    <td>文件费</td>
                    <td>50.00/票</td>
                </tr>
                <tr style="height:55px;">
                    <td><span style="display:inline-block;width:98px;">电子舱单信息</span></td>
                    <td>60.00/份， 两个分单或以上按分单数量计算。</td>
                </tr>
                <tr style="height:36px;">
                    <td>反恐舱单信息费</td>
                    <td>（经欧美国家）：50.00/份， 两个分单或以上按分单数量计算。</td>
                </tr>
                <tr style="height:36px;">
                    <td>如有叉车费</td>
                    <td>首叉40，续叉20/叉,（单件重超80K，或者有单边尺寸大于100CM的托盘）(垫板/加底/压仓/开箱等现场费用实付实收)</td>
                </tr>
                <tr style="height:55px;">
                    <td><span style="width:158px;display: inline-block;">
                            仓库操作费（含装卸+贴标签+短驳）</span></td>
                    <td>0.3/K(毛重)，MIN100.00/票</td>
                </tr>
                <tr style="height:106px;">
                    <td>化学品鉴定报告（如需）</td>
                    <td>
                        <p>普通400.00/品名（48小时出报告）+ 加班费实付实收</p>
                        <p>加急600.00/品名（24小时出报告）+ 加班费实付实收</p>
                        <p>工作日17点-21点及节假日17点前出报告100/票；</p>
                        <p>工作日21点后及节假日17点后出报告200/票</p>
                    </td>
                </tr>
                <tr style="height:106px;">
                    <td>磁检报告（如需）</td>
                    <td>
                        <p>100件以内400/票 + 加班费实付实收，</p>
                        <p>超出100件以上的部分 +1.00/件</p>
                        <p>工作日17点-21点及节假日17点前出报告100/票；</p>
                        <p>工作日21点后及节假日17点后出报告200/票</p>
                    </td>
                </tr>
            </table>
            <h1>深圳机场机场空运出口港杂费收费标准(币制RMB）</h1>
            <table class="common">
                <tr>
                    <td>报关费</td>
                    <td>250.00/份(客户提供单证, 且非电商类报关）</td>
                </tr>
                <tr>
                    <td>文件费</td>
                    <td>50.00/票</td>
                </tr>
                <tr>
                    <td>电子舱单信息</td>
                    <td>60.00/份， 两个分单或以上按分单数量计算</td>
                </tr>
                <tr style="height:55px;">
                    <td><span style="width:98px;display: inline-block;">反恐舱单信息费
                            （经欧美国家）</span></td>
                    <td>50.00/份， 两个分单或以上按分单数量计算</td>
                </tr>
                <tr>
                    <td>现场费用</td>
                    <td>鉴定费、垫板、开箱等现场费用实付实收</td>
                </tr>
            </table>
            <h1>香港机场机场空运出口港杂费收费标准(币制RMB）</h1>
            <table class="common">
                <tr>
                    <td>地面处理费</td>
                    <td>1.48/k(C.W.), MIN 400.0</td>
                </tr>
                <tr>
                    <td>文件费</td>
                    <td>50.00/票</td>
                </tr>
                <tr>
                    <td>操作费</td>
                    <td>150.00/票</td>
                </tr>
                <tr>
                    <td>X光机检查(如需)</td>
                    <td>300.00/票</td>
                </tr>
                <tr>
                    <td>香港区域提货:</td>
                    <td>0.45/KG（MIN:500/票），产生的等候费、登记费等杂费实付实收</td>
                </tr>
            </table>
            <h2>香港出口需要发货人自己向香港政府机构进行出口申报，如需要我司代为申报，请务必提前说明，请与在线/人工客服确认相关费用。</h2>
            <h1>长沙机场机场空运出口港杂费收费标准(币制RMB）</h1>
            <table class="common">
                <tr>
                    <td>报关费</td>
                    <td>300.00/份(客户提供单证, 且非电商类报关）</td>
                </tr>
                <tr>
                    <td>文件费</td>
                    <td>50.00/票</td>
                </tr>
                <tr>
                    <td>电子舱单信息</td>
                    <td>50.00/份， 两个分单或以上按分单数量计算</td>
                </tr>
                <tr style="height:55px;">
                    <td><span style="width:98px;display: inline-block;">反恐舱单信息费
                            （经欧美国家）</span></td>
                    <td>50.00/份， 两个分单或以上按分单数量计算</td>
                </tr>
                <tr>
                    <td>现场费用</td>
                    <td>鉴定费、垫板、开箱等现场费用实付实收</td>
                </tr>
            </table>
        </div>
</template>
<style scoped>
@import "~@/assets/css/view/about/incidentals.css";
</style>
<script type='babel'>
    export default {
        components: {
        	
    	}
    };
</script>